import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { ListingsAsyncActions } from 'store/actions/listings';
import { getAISummary } from 'store/selectors/listings';
import { CloseButton } from './offerCompareModal.styled';

function OfferCompareModal({ show, listingId, onClose }) {
  const dispatch = useDispatch();

  const aiSummary = useSelector(getAISummary);
  const { isSuccess: updateAiSummarySuccess, error: updateAiSummaryError } = useSelector(
    ListingsAsyncActions.FetchAISummary.StatusSelector()
  );

  useEffect(() => {
    dispatch(ListingsAsyncActions.FetchAISummary.Actions.REQUEST(listingId));

    return () => {
      dispatch(ListingsAsyncActions.FetchAISummary.Actions.RESET());
    };
  }, [dispatch, listingId]);

  return (
    <Modal show={show} aria-labelledby='offer-compare' backdrop='static' dialogClassName='modal-90wh' scrollable>
      <Modal.Body className='d-flex flex-column' scrollable>
        {!updateAiSummarySuccess && !updateAiSummaryError && <div>Loading AI Summary...</div>}
        {updateAiSummarySuccess && (
          <>
            <CloseButton onClick={onClose}>&times;</CloseButton>
            <div dangerouslySetInnerHTML={{ __html: aiSummary }} />
          </>
        )}
        {updateAiSummaryError && (
          <>
            <CloseButton onClick={onClose}>&times;</CloseButton>
            <div>Error Loading AI Summary</div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

OfferCompareModal.propTypes = {
  show: PropTypes.bool.isRequired,
  listingId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default OfferCompareModal;
